import React from 'react'
import { Box, Text, Title } from '@mantine/core'
import { usePricingVersionCache, useVersionRulesCache } from '../../../../hooks/global-job-matching'
import { useParams } from 'react-router'
import { getOperatorLabel } from '../../../../constants/filter-operators'

export const JobsStepDetails = () => {
  const params = useParams<{id: string}>()
  const rules = useVersionRulesCache(params.id)
  const version = usePricingVersionCache(params.id)
  const jobsSelection = rules?.jobsSelection === 'select' ? 'Select Jobs' : 'All Jobs'

  const showPropagate = version.matchStrategy === 'file' && version.shouldPropagate && rules.jobsSelection === 'all'
  const showFilters = rules?.jobsSelection === 'select' && rules.jobsFilter?.length

  return (
    <Box>
      <Title order={3} c='black'>Jobs</Title>
      <Text c='black' size='sm'>Set to use <Text span fw='bold' c='black' size='sm'>{jobsSelection}</Text></Text>
      { showPropagate &&
        <>
          <Text size='sm'>Propagate upload match priorities with <Text span c='black' size='sm'>"Propagate to {version.propagateMatchOption} jobs"</Text></Text>
          { !!version?.propagateMatchJobSelection?.length && version?.propagateMatchOption === 'select' && <Text>Propagate to job code keys <Text span c='black'>{version?.propagateMatchJobSelection.join(', ')}</Text></Text> }
        </>
      }
      { showFilters &&
      <>
        <Text c='black' size='sm'>Filter set to</Text>
        { rules.jobsFilter.map((filter, idx) => {
          return <Text key={idx} c='dimmed' size='sm'>{filter.element} {getOperatorLabel(filter.operator)} {filter.value}</Text>
        })}
      </>
      }
    </Box>
  )
}
